import { render, staticRenderFns } from "./ContactusPage.vue?vue&type=template&id=01a1917a&scoped=true"
import script from "./ContactusPage.vue?vue&type=script&lang=js"
export * from "./ContactusPage.vue?vue&type=script&lang=js"
import style0 from "./ContactusPage.vue?vue&type=style&index=0&id=01a1917a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1917a",
  null
  
)

export default component.exports